var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { class: _vm.slideInClass }, [
        _c("header", { staticClass: "titled" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "close-container" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.close.apply(null, arguments)
                  }
                }
              },
              [_c("Icon", { attrs: { icon: "close" } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "main",
          { staticClass: "scrollbar-check" },
          [
            _vm.subTitle ? _c("h2", [_vm._v(_vm._s(_vm.subTitle))]) : _vm._e(),
            _vm._v(" "),
            _c("b-textarea", {
              attrs: { rows: 10 },
              model: {
                value: _vm.notice,
                callback: function($$v) {
                  _vm.notice = $$v
                },
                expression: "notice"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "mt-2 font-size-smaller" }, [
              _vm._v("Deine Notizen sind nur für dich sichtbar.")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "footer",
          [
            _vm.hasNotice
              ? _c("Button", {
                  staticClass: "mr-2",
                  attrs: {
                    text: "Notiz löschen",
                    icon: "close",
                    secondary: "",
                    disabled: _vm.saving,
                    loading: _vm.saving
                  },
                  on: {
                    click: function($event) {
                      return _vm.save("")
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("Button", {
              staticClass: "mt-2 mt-md-0",
              attrs: {
                text: "Notiz speichern",
                icon: "checkmark",
                disabled: _vm.saving,
                loading: _vm.saving
              },
              on: {
                click: function($event) {
                  return _vm.save(_vm.notice)
                }
              }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h1", [_vm._v("Notiz")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }